import React, { useState, Fragment, useEffect } from "react";
import { Navigation } from "baseui/side-navigation";
import { styled, useStyletron } from "baseui";
import { useHistory, useLocation, useParams } from "react-router-dom";
import { Block } from "baseui/block";
const StyledUl = styled('ul', ({ $theme }) => ({
  paddingLeft: $theme.sizing.scale300,
  paddingRight: $theme.sizing.scale0,
  margin: $theme.sizing.scale0,
  height: '100%',
  ...$theme.typography.font200,
}));

function ModelerExecuteSidebarView({ items, onSelectedChanged }) {
  const history = useHistory();
  const location = useLocation();
  const { view } = useParams();

  const [activeItemId, setActiveItemId] = useState(view);
  return (
    <Block>
      <StyledUl>
        <Navigation
          items={items}
          activeItemId={activeItemId}
          onChange={({ event, item }) => {
            event.preventDefault();
            setActiveItemId(item.itemId);
            onSelectedChanged(item.itemId);
            history.push({
              pathname: item.itemId,
              search: location.search, // retains the current search string
          });          }}
          mapItem={(item) => ({ title: item.title, itemId: item.itemId })}
          overrides={{
            NavLink: {
              style: ({ $theme }) => ({
                textDecoration: "none!important",              }),
            },
            NavItem: {
              style: ({ $active, $theme }) => {
                if (!$active) {
                  return {
                    ':hover': {
                      color: $theme.colors.accent,
                    },
                  };
                }
                return {
                  backgroundColor: $theme.colors.accent,
                  borderLeftColor: $theme.colors.accent,
                  color: $theme.colors.mono900,
                  ':hover': {
                    color: $theme.colors.accent400,
                  },
                };
              },
            },
          }}
        />
      </StyledUl>
    </Block>
  );
}

export default ModelerExecuteSidebarView;
